import api from "../../../services/api";

const APIS = {
  GET_COMPANIES: "/Companies",
  GET_PRODUCT_TYPES: "/ProductTypes",
  GET_SPECIES: "/Species",
  GET_DASHBOARD_DATA: "/FieldStaffDashBoard/fieldstaff-dashboard"
};

export const getCompanies = async (pageNumber = 1, pageSize = 1000) => {
  try {
    const res = await api.get(`${APIS.GET_COMPANIES}?PageNumber=${pageNumber}&PageSize=${pageSize}`);
    return {
      results: Array.isArray(res.data.results) ? res.data.results : [],
      success: true
    };
  } catch (error) {
    console.error("Get companies error:", error);
    return { results: [], success: false };
  }
};

export const getProductTypes = async () => {
  try {
    const res = await api.get(APIS.GET_PRODUCT_TYPES);
    return {
      results: Array.isArray(res.data) ? res.data : [],
      success: true
    };
  } catch (error) {
    console.error("Get product types error:", error);
    return { results: [], success: false };
  }
};

export const getSpecies = async () => {
  try {
    const res = await api.get(APIS.GET_SPECIES);
    return {
      results: Array.isArray(res.data) ? res.data : [],
      success: true
    };
  } catch (error) {
    console.error("Get species error:", error);
    return { results: [], success: false };
  }
};

export const getDashboardData = async (filters = {}) => {
  try {
    const params = {
      companyId: filters.companyId || 0,
      productTypeId: filters.productType || 0,
      speciesId: filters.species || 0,
      fromDate: filters.fromDate || '',
      toDate: filters.toDate || ''
    };

    const res = await api.post(APIS.GET_DASHBOARD_DATA, params);
    return {
      labProductTrend: res.data.labProductTrend || { labTrends: [] },
      sampleStatusPie: res.data.sampleStatusPie || {
        requestedCount: 0,
        receivedCount: 0,
        inProgressCount: 0,
        completedCount: 0,
        countGreaterThanTenDays: 0,
        countGreaterThanFourteenDays: 0
      },
      customerSamplesCompleted: res.data.customerSamplesCompleted || { companySamples: [] },
      success: true
    };
  } catch (error) {
    console.error("Get dashboard data error:", error);
    return {
      labProductTrend: { labTrends: [] },
      sampleStatusPie: {
        requestedCount: 0,
        receivedCount: 0,
        inProgressCount: 0,
        completedCount: 0,
        countGreaterThanTenDays: 0,
        countGreaterThanFourteenDays: 0
      },
      customerSamplesCompleted: { companySamples: [] },
      success: false
    };
  }
};
